import React, { ReactNode } from 'react';
type TitleType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
export interface TitleValueProps {
  value: TitleProps
}
interface TitleProps {
  type: TitleType;
  className?: string;
  children: ReactNode;
}
const Title: React.FC<TitleValueProps> = ({ value}) => {
  const { type, className, children } = value;
  const TitleTag = type;

  return <TitleTag className={className}>{children}</TitleTag>;
};
export default Title;